import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[progressPercentIcon]',
  standalone: true,
})
export class ProgressPercentIconDirective implements OnInit {
  @Input('progressPercentIcon') progressPercent: number;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi ';

    switch (true) {
      case this.progressPercent < 20:
        classList += 'mdi-circle-slice-2 mdi-22px text-info';
        break;
      case this.progressPercent < 40:
        classList += 'mdi-circle-slice-3 mdi-22px text-info';
        break;
      case this.progressPercent < 60:
        classList += 'mdi-circle-slice-4 mdi-22px text-info';
        break;
      case this.progressPercent < 80:
        classList += 'mdi-circle-slice-6 mdi-22px text-info';
        break;
      case this.progressPercent < 100:
        classList += 'mdi-circle-slice-7 mdi-22px text-info';
        break;
      case this.progressPercent == 100:
        classList += 'mdi-circle-slice-8 mdi-22px text-info';
        break;

      default:
        break;
    }

    return classList;
  }
}
